import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SERVICE_DETAILS } from "../../data/content";

export const ServiceDetails = () => {
  return (
    <section id="service-details" className="section-anchor py-16 sm:py-20 bg-white border-y">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <h2 className="text-2xl sm:text-3xl font-semibold tracking-tight text-[color:var(--brand-navy)]">
            Basic and Advanced Fingerprint Services
          </h2>
          <p className="mt-3 text-muted-foreground leading-relaxed">
            Our experienced fingerprint technicians do more than just capture your fingerprints. Using digital
            technology and trusted partnerships, we prepare and electronically transmit required documentation directly
            to the appropriate agency for expedited processing &mdash; available for one, all-inclusive service fee.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-8" data-testid="service-details-accordion">
          {SERVICE_DETAILS.map((group) => (
            <div key={group.id} id={group.id} className="section-anchor">
              <h3 className="font-heading font-semibold text-lg text-[color:var(--brand-navy)] mb-3 pb-3 border-b-2 border-[color:var(--brand-sky)]">
                {group.title}
              </h3>
              <Accordion type="single" collapsible className="w-full">
                {group.items.map((item, idx) => (
                  <AccordionItem key={idx} value={`${group.id}-${idx}`}>
                    <AccordionTrigger className="text-left font-heading text-sm font-medium hover:text-[color:var(--brand-sky)]">
                      {item.q}
                    </AccordionTrigger>
                    <AccordionContent className="text-sm text-muted-foreground leading-relaxed max-w-2xl">
                      {item.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
